import React from 'react';
import { Container } from './Spacer.style';

const Spacer = ({height}) => {
  return(
    <Container height={height} />
  )
}

export default Spacer;